import dayjs from 'dayjs';
import { ApiService, DataService } from "../service";

export class CertifService {
  static async certifList(compId: number, page: number, pageSize: number) {
    return DataService.get(`${ApiService.JrzzApi}/site/certificate/GetCertificateList?page=${page}&pageSize=${pageSize}&compId=${compId}`);
  }
}

export class CompService {

  /**
   * 拼接企业logo
   * @param src 
   * @param width 
   * @param height 
   * @returns 
   */
  static getCompLogo(src: string, width = 0, height = 0) {
    if (!src) {
      return '';
    }
    if(/\.[a-zA-Z]+$/.test(src)) {
      return src;
    } else {
      return `${ApiService.ImageHost}/${src}_${width}x${height||width}.jpg`;
    }
  }

  /**
   * 根据企业id获取企业主banner图
   * @param compId 
   * @returns 
   */
  static getCompMainBanner(compId: string) {
    return `${ApiService.ImageHost}/Templet/Comp/Default/${compId}/index_banner_0x0.jpg?v=${dayjs(dayjs().format('YYYY-MM-DD HH')).valueOf()}`;
  }

  // =======================================
  // ====== SiteCompPic 企业图册 START ======
  // =======================================
  static async getCompPicList(compId: number, page: number, pageSize: number) {
    return await DataService.get(`${ApiService.JrzzApi}/site/comppic/GetCompPicList?compId=${compId}&page=${page}&pageSize=${pageSize}`);
  }
  // =====================================
  // ====== SiteCompPic 企业图册 END ======
  // =====================================

  // =====================================
  // ====== SiteNews 企业新闻 START ======
  // =====================================
  static async getNewsList(compId: number, page: number, pageSize: number) {
    return await DataService.get(`${ApiService.JrzzApi}/site/news/GetNewsList?compId=${compId}&page=${page}&pageSize=${pageSize}`);
  }
  // 获取新闻详情
  static async getNewsInfo(newsId: string) {
    return await DataService.get(`${ApiService.JrzzApi}/site/news/GetNewsInfo?newsId=${newsId}`);
  }
  // =====================================
  // ====== SiteNews 企业新闻 END ======
  // =====================================

  // 获取企业信息
  static async getCompInfo(compId: number) {
    var url = `${ApiService.JrzzApi}/site/comp/GetCompInfo?compId=${compId}`;
    return await DataService.get(url);
  }
  // 获取企业信息(杭州接口服务)
  static async getCompanyInfo(compId: number) {
    var url = `${ApiService.EngineerApi}/search/getCompanyInfo?companyId=${compId}`;
    var res = await DataService.get(url);
    !res.data && (res.data = {});
    for (var key in res.data) {
			res.data[key.substring(0, 1).toUpperCase() + key.substring(1)] = res.data[key];
		}
    return res;
  }

  static getSInfo(compMdt: string) {
    return DataService.get(`${ApiService.JrzzApi}/comp/GetSInfo?compMdt=${compMdt}`);
  }

  // 获取企业富文本介绍信息
  static getCompIntro(compId: number) {
    return DataService.get(`${ApiService.JrzzApi}/site/comp/GetCompIntro?compId=${compId}`);
  }

  static GetPublicUsers(compId: number) {
    return DataService.get(`${ApiService.JrzzApi}/site/comp/GetPublicUsers?compId=${compId}`);
  }

  // 加入我的资源
  static enterpriseInsert(DirID: number, DirCategoryID: number, CompID: number, Remark: string, CompName: string) {
    return DataService.post(`${ApiService.JrzzApi}/res/add?dirId=${DirID}&dirCategoryId=${DirCategoryID}`, {
      DirID,
      CompID,
      Remark,
      CompName,
      DirCategoryID,
    });
  }

  // 判断是否已是资源
  static enterpriseExist(compId: number, offErrorMsg = false) {
    return DataService.get(`${ApiService.JrzzApi}/res/exists?compId=${compId}`, {}, { offErrorMsg });
  }

  // 从solr中获取列表
  static async compGetSlist(params: any) {
    let url = `${ApiService.JrzzApi}/comp/GetSList`;
    Object.keys(params).forEach((item, index) => {
      const tags = index === 0 ? "?" : "&";
      // @ts-ignore
      url = url + `${tags}${item}=${params[item]}`;
    });
    return await DataService.get(url);
  }

  /**
   * 获取金银铜企业列表
   * @param levelName 等级
   * @param cid 分类id
   * @param page 页码默认1
   * @param limit 数量默认15
   * @returns
   */
  static async getVipCompanyList(levelName: string, cid: string, page: number = 1, limit: number = 15) {
    let levelNameurl = '';
    levelName && (levelNameurl = `&levelName=${levelName}`)
    let cidUrl = '';
    Number(cid) != 1 && (cidUrl = `&cid=${cid}`)
    return DataService.get(`${ApiService.ZPChainApi}/supplier/getCompanyList?page=${page}&limit=${limit}${cidUrl}${levelNameurl}`);
  }

  //判断用户的企业vip状态  'vip级别 0普通 1认证 2蓝V铜牌 4蓝V银牌 8红V 16黄V 32蓝V金牌 64蓝V钻石',
	static blueVip(vipLevel: number = 0) {
		if ((vipLevel & 64) == 64) {
			return "金牌";
		} else if ((vipLevel & 32) == 32) {
			return "金牌";
		} else if ((vipLevel & 4) == 4) {
			return "银牌";
		} else if ((vipLevel & 2) == 2) {
			return "铜牌";
		} else {
			return "";
		}
	}

  static async getDataBriefingt(compId: number) {
    return DataService.get(`${ApiService.EngineerApi}/share/getDataBriefing?compId=${compId}`);
  }
}
